import type { ComponentPropsWithoutRef, JSX } from 'react';

import { Box } from '@change-corgi/design-system-legacy/layout';
import { useIsSunriseTheme } from '@change-corgi/design-system-legacy/theme';
import { Text } from '@change-corgi/design-system-legacy/typography';

type Props = ComponentPropsWithoutRef<typeof Box> & {
	title: string;
	time: string;
};

export function ActivityPill({ title, time, sx, ...rest }: Props): JSX.Element {
	const isSunriseThemeEnabled = useIsSunriseTheme();
	return (
		<Box
			sx={{
				display: 'inline-flex',
				backgroundColor: isSunriseThemeEnabled ? 'sunrise.semantic.fill.inverse.weak' : '#F9F9F9',
				borderRadius: '1000rem',
				gap: 4,
				paddingX: 12,
				paddingY: 8,
				// eslint-disable-next-line @typescript-eslint/no-misused-spread
				...sx,
			}}
			{...rest}
		>
			<Text data-nosnippet size="small">
				{title}
			</Text>
			<Text size="small" color="typography-secondary">
				•
			</Text>
			<Text size="small" color="typography-secondary">
				{time}
			</Text>
		</Box>
	);
}
